import styled from '@emotion/styled';
import { Link } from '~/shared/components/Link';

export const Container = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.space[1],
}));

export const LabelButton = styled.button({
    display: 'block',
    padding: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
});

export const TextLink = styled(Link)(({ theme }) => ({
    color: theme.colors.nightBlack,
    fontSize: theme.fontSizes.mouse,
}));
